import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { FaChevronRight } from 'react-icons/fa';

const Headers = ({ page }) => {
  return (
    <Card
      className='mb-2 border-0 shadow-sm'
      style={{
        borderRadius: 16,
        overflow: 'hidden'
      }}
    >
      <div
        className='p-3'
        style={{
          background: 'linear-gradient(to right, rgba(28, 66, 32, 0.95), rgba(143, 173, 21, 0.9))',
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        <Row className="align-items-center">
          <Col>
            <div className="d-flex align-items-center">
              <div>
                <p className="text-white mb-1 opacity-75" style={{
                  fontSize: '0.85rem',
                  fontWeight: '500',
                  letterSpacing: '0.5px'
                }}>
                  GERENCIAMENTO
                </p>
                <h4 className="text-white mb-0 fw-bold" style={{
                  letterSpacing: '0.5px',
                  position: 'relative',
                  zIndex: 2
                }}>
                  {page ? page.toUpperCase() : '--'}
                </h4>
              </div>
            </div>
          </Col>
          <Col xs="auto" className="d-none d-md-block">
            <div className="d-flex align-items-center text-white opacity-75">
              <span className="small me-2">SGU</span>
              <FaChevronRight size={12} />
              <span className="small mx-2 fw-medium">{page || '--'}</span>
            </div>
          </Col>
        </Row>

        {/* Elementos decorativos de fundo */}
        <div
          className="position-absolute"
          style={{
            right: '-20px',
            top: '-10px',
            width: '80px',
            height: '80px',
            background: 'rgba(255, 255, 255, 0.1)',
            borderRadius: '50%',
            zIndex: 0
          }}
        />
        <div
          className="position-absolute"
          style={{
            left: '15%',
            bottom: '-15px',
            width: '40px',
            height: '40px',
            background: 'rgba(255, 255, 255, 0.06)',
            borderRadius: '50%',
            zIndex: 0
          }}
        />
      </div>
    </Card>
  );
};

export default Headers;
